import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaAccordion from './VaAccordion.vue'

export default withConfigTransport(VaAccordion)
